import i18n from '@/common/js/i18n'
import pagecPopupIndex from '@/page/banner/cPopup/index'

export default {
  path: '/banner-c-popup',
  name: 'bannerCPopup',
  meta: {
    title: i18n.gettext('C运营弹窗')
  },
  component: pagecPopupIndex
  // component: () => import(/* webpackChunkName: "banner" */ '@/page/banner/cPopup/index')
}
